import { CSSProperties, useMemo } from 'react';

import { Box, Stack, SxProps, Theme, Typography } from '@mui/material';

import { DisplayCurrency } from 'src/components';

interface OrderSumCardProps {
    title: string;
    value: number | string;
    icon?: React.ReactNode;
    titleContainerStyles?: SxProps<Theme>;
    containerStyles?: SxProps<Theme>;
    labelTypographyStyles?: SxProps<Theme>;
    valueTypographyStyles?: SxProps<Theme>;
    usersCurrency?: string;
}

const OrderSumCard = ({
    title,
    value,
    icon,
    titleContainerStyles,
    containerStyles,
    labelTypographyStyles,
    valueTypographyStyles,
    usersCurrency,
}: OrderSumCardProps) => {
    const { wrapperStyles, titleStyles, labelStyles, valueStyles } = useMemo(() => {
        return {
            wrapperStyles: {
                border: '1px solid #FEE380',
                borderRadius: '8px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                ...containerStyles,
            } as SxProps<Theme>,
            valueStyles: {
                fontSize: '24px',
                fontWeight: '700',
                color: '#575757',
                textAlign: 'center',
                my: '16px',
                ...valueTypographyStyles,
            } as SxProps<Theme>,
            titleStyles: {
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#F39E4E',
                padding: '8px 16px',
                borderRadius: '8px 8px 0 0',
                ...titleContainerStyles,
            } as SxProps<Theme>,
            labelStyles: {
                fontSize: '24px',
                fontWeight: 500,
                color: '#FFFCF0',
                textAlign: 'center',
                ...labelTypographyStyles,
            } as SxProps<Theme>,
        };
    }, [valueTypographyStyles, containerStyles, titleContainerStyles, labelTypographyStyles]);

    return (
        <Box sx={wrapperStyles}>
            <Stack sx={titleStyles} gap={2}>
                {icon}
                <Typography data-testid="order-sum-card-title" sx={labelStyles}>
                    {title}
                </Typography>
            </Stack>
            {(() => {
                if (typeof value === 'number') {
                    return (
                        <DisplayCurrency
                            centsAmount={value}
                            style={valueStyles as CSSProperties}
                            usersCurrency={usersCurrency}
                        />
                    );
                }
                return (
                    <Typography data-testid="order-sum-card-value" sx={valueStyles}>
                        {value}
                    </Typography>
                );
            })()}
        </Box>
    );
};
export default OrderSumCard;
